import React, { useEffect, useState } from 'react';
import {
	Button,
	TextField,
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Dialog,
	DialogContent,
	Container,
	TableSortLabel,
	InputAdornment,
	Switch,
	Grid,
	Typography,
	CircularProgress,
	Tooltip,
	DialogTitle,
	DialogActions,
	TablePagination,
	// Snackbar,
	// Alert,
	Card,
	CardMedia,
} from '@mui/material';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/system';
import CreateSubCategory from './CreateSubCatergories';
import {
	deleteSubCatergry,
	getAllSubCategories,
	updateSubCategory,
} from '../../../services/api/Subcategories';
import Toast from '../Toast/page';

export interface SubCategory {
	_id: string;
	category: any;
	subCategory: string;
	description: string;
	status: string;
	slug: string;
	createdBy: string;
	subCategoryImage: string | File;
	createdAt: string;
	updatedAt: string;
}

const SubCategories = () => {
	const [subCategories, setSubCategories] = useState<SubCategory[]>([]);
	const [searchTerm, setSearchTerm] = useState('');
	const [isGridView, setIsGridView] = useState(false);
	const [openDialog, setOpenDialog] = useState(false);
	const [currentSubCategory, setCurrentSubCategory] = useState<SubCategory | null>(null);
	const [order, setOrder] = useState<'asc' | 'desc'>('asc');
	const [orderBy, setOrderBy] = useState<keyof SubCategory>('createdAt');
	const [loading, setLoading] = useState(true);
	const [descriptionDialogOpen, setDescriptionDialogOpen] = useState(false);
	const [selectedDescription, setSelectedDescription] = useState('');
	const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
	const [subCategoryToDelete, setSubCategoryToDelete] = useState<string | null>(null);
	const [alertMessage, setAlertMessage] = useState<string | null>(null);
	const [alertSeverity, setAlertSeverity] = useState<'success' | 'error'>('success');
	const [updatingId, setUpdatingId] = useState<string | null>(null);
	const [visibleItems, setVisibleItems] = useState(28);

	// Pagination state
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(25);

	const handleAddSubCategory = () => {
		setCurrentSubCategory(null);
		setOpenDialog(true);
	};

	const handleEditSubCategory = (subCategory: SubCategory) => {
		setCurrentSubCategory(subCategory);
		setOpenDialog(true);
	};

	const handleDeleteClick = (id: string) => {
		setSubCategoryToDelete(id);
		setDeleteDialogOpen(true);
	};

	const handleConfirmDelete = async () => {
		if (subCategoryToDelete) {
			const response = await deleteSubCatergry(subCategoryToDelete);
			if (response.success) {
				fetchSubCategories();
				setAlertMessage(response.data.message);
				setAlertSeverity('success');
			} else {
				setAlertMessage(response.error);
				setAlertSeverity('error');
			}
		}
		setDeleteDialogOpen(false);
		setSubCategoryToDelete(null);
	};

	const handleCloseDeleteDialog = () => {
		setDeleteDialogOpen(false);
		setSubCategoryToDelete(null);
	};

	const handleCloseDialog = () => {
		setOpenDialog(false);
		setCurrentSubCategory(null);
		fetchSubCategories();
	};

	const handleToggleStatus = async (id: string, currentStatus: string) => {
		const newStatus = currentStatus === '1' ? '0' : '1';
		try {
			setUpdatingId(id);
			const formData = new FormData();
			formData.append('status', newStatus);

			// If you need to send all subcategory data:
			const subCategory = subCategories.find((sc) => sc._id === id);
			if (subCategory) {
				formData.append('subCategory', subCategory.subCategory);
				formData.append('description', subCategory.description);
				// Append other fields as needed
				if (subCategory.subCategoryImage instanceof File) {
					formData.append('subCategoryImage', subCategory.subCategoryImage);
				}
			}

			const response = await updateSubCategory(formData, id);
			const data = await response.json();
			console.log(data, 'response');
			if (data.success) {
				setSubCategories((prev) =>
					prev.map((item) => (item._id === id ? { ...item, status: newStatus } : item))
				);
				setAlertMessage(data.message);
				setAlertSeverity('success');
			} else {
				setAlertMessage(data.error);
				setAlertSeverity('error');
			}
		} catch (error) {
			setAlertMessage('Failed to update status');
			setAlertSeverity('error');
			console.error('Error updating status:', error);
		} finally {
			setUpdatingId(null);
		}
	};

	const fetchSubCategories = async () => {
		try {
			setLoading(true);
			const response = await getAllSubCategories();
			setSubCategories(
				response?.data?.subcategories.reverse() || [
					{
						_id: '67e0f37bc47deb61d912f162',
						category: 'Updated sweets',
						subCategory: 'watermelon(வாட்டர்மெலான்)',
						description: 'dddddddddddd',
						status: '1',
						slug: 'watermelon()',
						createdBy: '67b86f262d58e0bf4062a432',
						createdAt: '2025-03-24T05:54:03.223Z',
						updatedAt: '2025-03-24T05:54:03.223Z',
					},
				]
			);
		} catch (error) {
			console.error('Error fetching subcategories:', error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchSubCategories();
	}, []);

	const handleSort = (property: keyof SubCategory) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const filteredSubCategories = subCategories
		.filter(
			(subCategory) =>
				subCategory.subCategory.toLowerCase().includes(searchTerm.toLowerCase()) ||
				subCategory.category.toLowerCase().includes(searchTerm.toLowerCase())
		)
		.sort((a, b) => {
			const aValue = a[orderBy];
			const bValue = b[orderBy];

			if (orderBy === 'createdAt' || orderBy === 'updatedAt') {
				return order === 'asc'
					? new Date(aValue).getTime() - new Date(bValue).getTime()
					: new Date(bValue).getTime() - new Date(aValue).getTime();
			}

			if (typeof aValue === 'string' && typeof bValue === 'string') {
				return order === 'asc'
					? aValue.localeCompare(bValue)
					: bValue.localeCompare(aValue);
			}
			return 0;
		});

	// Pagination handlers
	const handleChangePage = (event: unknown, newPage: number) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	// const formatDate = (dateString: string) => {
	// 	const date = new Date(dateString);
	// 	return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
	// };

	const truncateDescription = (description: string, maxLength: any = 50) => {
		if (!description) return '';
		if (description.length <= maxLength) return description;
		return `${description.substring(0, maxLength)}...`;
	};

	const handleCloseDescriptionDialog = () => {
		setDescriptionDialogOpen(false);
		setSelectedDescription('');
	};

	return (
		<>
			<Container maxWidth={false} sx={{ width: '100%', pt: 3, pb: 4 }}>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<div>
						<TextField
							label="Search..."
							variant="outlined"
							value={searchTerm}
							onChange={async (e) => {
								const value = e.target.value;
								setSearchTerm(value);
								setPage(0); // Reset to the first page when a search is performed

								try {
									setLoading(true);
									const response = await getAllSubCategories();
									const allSubCategories = response?.data?.subcategories || [];
									const filtered = allSubCategories.filter(
										(subCategory: SubCategory) =>
											subCategory.subCategory
												.toLowerCase()
												.includes(value.toLowerCase()) ||
											subCategory.category
												.toLowerCase()
												.includes(value.toLowerCase())
									);
									setSubCategories(filtered);
								} catch (error) {
									console.error('Error searching subcategories:', error);
								} finally {
									setLoading(false);
								}
							}}
							size="small"
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<SearchIcon />
									</InputAdornment>
								),
							}}
						/>
					</div>
					<div>
						<Button
							variant="contained"
							color="primary"
							onClick={handleAddSubCategory}
							style={{ background: '#CA0005' }}
						>
							Add Sub Category
						</Button>
					</div>
				</div>

				<Grid container spacing={2} sx={{ mb: 2, mt: 2 }}>
					<Grid item xs={12} sm={7}></Grid>
					<Grid item xs={12} sm={5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Tooltip title="Grid View">
							<IconButton onClick={() => setIsGridView(true)}>
								<ViewModuleIcon color={isGridView ? 'primary' : 'inherit'} />
							</IconButton>
						</Tooltip>
						<Tooltip title="Table View ">
							<IconButton onClick={() => setIsGridView(false)}>
								<ViewListIcon color={!isGridView ? 'primary' : 'inherit'} />
							</IconButton>
						</Tooltip>
					</Grid>
				</Grid>

				{loading ? (
					<div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
						<CircularProgress />
					</div>
				) : isGridView ? (
					<>
						<div
							className="grid-view"
							style={{
								display: 'grid',
								gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
								gap: '20px',
								// height: '55vh',
								// overflowY: 'auto',
							}}
						>
							{filteredSubCategories
								.reverse()
								.slice(0, visibleItems)
								.map((sc) => (
									<Paper key={sc._id} elevation={3} sx={{ p: 1 }}>
										<Card>
											<CardMedia
												component="img"
												alt="Sub Category Image"
												height="140"
												image={
													sc.subCategoryImage instanceof File
														? URL.createObjectURL(sc.subCategoryImage)
														: sc.subCategoryImage ||
															'/placeholder-image.jpg'
												}
												// sx={{
												// 	objectFit: 'cover',
												// 	backgroundColor: '#f5f5f5',
												// }}
												sx={{
													objectFit: 'contain',
													filter:
														sc?.status == '0'
															? 'grayscale(100%) opacity(0.5)'
															: 'none',
													transition: 'filter 0.3s',
												}}
											/>
										</Card>
										<Typography
											variant="h6"
											sx={{ fontSize: '15px', marginTop: '5px' }}
											gutterBottom
										>
											{sc.subCategory}
										</Typography>
										<Typography
											variant="body2"
											color="text.secondary"
											gutterBottom
										>
											<span style={{ fontWeight: '400' }}>Category:</span>{' '}
											{sc.category}
										</Typography>
										<Typography
											variant="body2"
											color="text.secondary"
											gutterBottom
										>
											<span style={{ fontWeight: '400' }}>Description:</span>{' '}
											<Tooltip title={sc.description}>
												<span>{truncateDescription(sc.description)}</span>
											</Tooltip>
										</Typography>
										{/* <Typography
											variant="body2"
											color="text.secondary"
											gutterBottom
										>
											<span style={{ fontWeight: '400' }}>Status:</span>{' '}
											{sc.status === '1' ? 'Active' : 'Inactive'}
										</Typography> */}
										<div
											style={{
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
												marginTop: '8px',
											}}
										>
											<Switch
												checked={sc.status === '1'}
												onChange={() =>
													handleToggleStatus(sc._id, sc.status)
												}
												color="primary"
												disabled={updatingId === sc._id}
											/>
											<div>
												<Tooltip title="Edit">
													<IconButton
														onClick={() => handleEditSubCategory(sc)}
													>
														<EditIcon />
													</IconButton>
												</Tooltip>
												<Tooltip title="Delete">
													<IconButton
														onClick={() => handleDeleteClick(sc._id)}
													>
														<DeleteIcon />
													</IconButton>
												</Tooltip>
											</div>
										</div>
									</Paper>
								))}
						</div>
						<Box sx={{ margin: 'auto' }}>
							{visibleItems < filteredSubCategories.length && (
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
										marginTop: '20px',
									}}
								>
									<Button
										variant="outlined"
										onClick={() => setVisibleItems((prev) => prev + 10)}
										sx={{ mt: 1, ':hover': { color: 'black' } }}
									>
										Load More
									</Button>
								</div>
							)}
						</Box>
					</>
				) : (
					<>
						<TableContainer component={Paper}>
							<Table>
								<TableHead>
									<TableRow>
										{[
											'subCategory',
											'category',
											'description',
											'status',
											// 'createdAt',
											// 'updatedAt',
										].map((key) => (
											<TableCell key={key}>
												<TableSortLabel
													active={orderBy === key}
													direction={orderBy === key ? order : 'asc'}
													onClick={() =>
														handleSort(key as keyof SubCategory)
													}
												>
													{key === 'subCategory'
														? 'Sub Category'
														: key === 'category'
															? 'Category'
															: key === 'createdAt'
																? 'Created At'
																: key === 'updatedAt'
																	? 'Updated At'
																	: key.charAt(0).toUpperCase() +
																		key.slice(1)}
												</TableSortLabel>
											</TableCell>
										))}
										<TableCell>Actions</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{filteredSubCategories
										.reverse()
										.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
										.map((sc) => (
											<TableRow key={sc._id}>
												<TableCell>{sc.subCategory}</TableCell>
												<TableCell>{sc.category}</TableCell>
												<TableCell>
													<Tooltip title={sc.description}>
														<span>
															{truncateDescription(sc.description)}
														</span>
													</Tooltip>
												</TableCell>
												<TableCell>
													<Switch
														checked={sc.status === '1'}
														onChange={() =>
															handleToggleStatus(sc._id, sc.status)
														}
														color="primary"
													/>
												</TableCell>
												<TableCell sx={{ textAlign: 'center' }}>
													<Typography
														variant="body2"
														color="text.secondary"
														sx={{ display: 'flex', gap: 1 }}
													>
														<Tooltip title="Edit">
															<IconButton
																onClick={() =>
																	handleEditSubCategory(sc)
																}
																disabled={sc.status === '0'}
															>
																<EditIcon />
															</IconButton>
														</Tooltip>
														<Tooltip title="Delete">
															<IconButton
																onClick={() =>
																	handleDeleteClick(sc._id)
																}
																disabled={sc.status === '0'}
															>
																<DeleteIcon />
															</IconButton>
														</Tooltip>
													</Typography>
												</TableCell>
											</TableRow>
										))}
								</TableBody>
							</Table>
						</TableContainer>
						<TablePagination
							rowsPerPageOptions={[5, 10, 25]}
							component="div"
							count={filteredSubCategories.length}
							rowsPerPage={rowsPerPage}
							page={page}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
							sx={{
								'.MuiTablePagination-toolbar': {
									justifyContent: 'flex-start',
								},
							}}
						/>
					</>
				)}

				<Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
					<DialogTitle>
						{currentSubCategory ? 'Edit Sub-Category' : 'Create New Sub-Category'}
						<IconButton
							aria-label="close"
							onClick={handleCloseDialog}
							sx={{
								position: 'absolute',
								right: 8,
								top: 8,
								color: (theme) => theme.palette.grey[500],
							}}
						>
							<CloseIcon />
						</IconButton>
					</DialogTitle>
					<DialogContent>
						<CreateSubCategory
							subCategory={currentSubCategory}
							onClose={handleCloseDialog}
						/>
					</DialogContent>
				</Dialog>

				{/* Description View Dialog */}
				<Dialog
					open={descriptionDialogOpen}
					onClose={handleCloseDescriptionDialog}
					maxWidth="sm"
					fullWidth
				>
					<DialogTitle>
						Description
						<IconButton
							aria-label="close"
							onClick={handleCloseDescriptionDialog}
							sx={{
								position: 'absolute',
								right: 8,
								top: 8,
								color: (theme) => theme.palette.grey[500],
							}}
						>
							<CloseIcon />
						</IconButton>
					</DialogTitle>
					<DialogContent dividers>
						<Typography variant="body1" style={{ whiteSpace: 'pre-line' }}>
							{selectedDescription}
						</Typography>
					</DialogContent>
					<DialogActions>
						<Button onClick={handleCloseDescriptionDialog}>Close</Button>
					</DialogActions>
				</Dialog>

				{/* Delete Confirmation Dialog */}
				<Dialog
					open={deleteDialogOpen}
					onClose={handleCloseDeleteDialog}
					maxWidth="xs"
					fullWidth
				>
					<DialogTitle>Confirm Delete</DialogTitle>
					<DialogContent>
						<Typography variant="body1">
							Are you sure you want to delete this subcategory? This action cannot be
							undone.
						</Typography>
					</DialogContent>
					<DialogActions>
						<Button onClick={handleCloseDeleteDialog} color="primary">
							Cancel
						</Button>
						<Button onClick={handleConfirmDelete} color="error" variant="contained">
							Delete
						</Button>
					</DialogActions>
				</Dialog>
			</Container>
			{/* <Snackbar
				open={Boolean(alertMessage)}
				autoHideDuration={3000}
				onClose={() => setAlertMessage(null)}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
			>
				<Alert
					severity={alertSeverity}
					variant="filled"
					onClose={() => setAlertMessage(null)}
					sx={{ width: '100%' }}
				>
					{alertMessage}
				</Alert>
			</Snackbar> */}

			<Toast
				alertMessage={alertMessage}
				alertSeverity={alertSeverity}
				setAlertMessage={setAlertMessage}
			/>
		</>
	);
};

export default SubCategories;
